//#region src/pinata_api_server.ts
var PinataApiServer = /* @__PURE__ */ function(PinataApiServer) {
	PinataApiServer[PinataApiServer["DigitalOcean"] = 2] = "DigitalOcean";
	PinataApiServer[PinataApiServer["Localhost"] = 3] = "Localhost";
	return PinataApiServer;
}(PinataApiServer || {});
//#endregion
export { PinataApiServer };

//# sourceMappingURL=pinata_api_server.js.map